import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NgIf } from '@angular/common';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'app-over-consumption-dialog',
    standalone: true,
    imports: [NgIf, MatDialogModule, MatButtonModule, FlexLayoutModule, FlexModule, MatListModule],
    template: `


      <div class="saving-content">
<svg xmlns="http://www.w3.org/2000/svg" width="44" height="38" viewBox="0 0 44 38" fill="none">
  <path d="M0 38H44L22 0L0 38ZM24 32H20V28H24V32ZM24 24H20V16H24V24Z" fill="url(#paint0_linear_2477_70)"/>
  <defs>
    <linearGradient id="paint0_linear_2477_70" x1="17.389" y1="11.0396" x2="51.9978" y2="34.0945" gradientUnits="userSpaceOnUse">
      <stop stop-color="#F79009"/>
      <stop offset="1" stop-color="#D47800"/>
    </linearGradient>
  </defs>
</svg>
    <label class="dialogHeader" style="padding-top: 28px;"> High Consumption Warning</label>
        <div style="width: 100%;">
<mat-list class="readings-list">

  @for (r of data.readings; track $index; let last = $last) {
    <mat-list-item class="readings-item">
      <div class="row">
        <span class="label">{{ r.label }}</span>
        <span class="value">{{ r.value }}</span>
      </div>
    </mat-list-item>

    @if (!last) {
      <mat-divider></mat-divider>
    }
  }

</mat-list>

      </div>
       

      <div class="devider"></div>
   <div fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="8" style="padding-top:12px; padding-left: 0px; padding-right: 0px;">
      <button mat-button style="width: 100%; background:#fff !important" (click)="review()">REVIEW</button>
      <button  mat-flat-button color="warn" style="width: 100%;" (click)="continue()">CONTINUE</button>
    </div>

  `, styles: [`
  .mat-mdc-button:not(:disabled) {
  border-radius: 4px;
  border: 1px solid var(--greyscale-border-light, #e2e2e2);
   color:  #060809 !important;
   background: #fff !important;
}
::ng-deep .mdc-dialog--open .mat-mdc-dialog-surface, .mdc-dialog--closing .mat-mdc-dialog-surface {
    transform: none;
    background: none !important;
}


.readings-list {
  width: 100%;
  padding: 0;
}

.readings-item {
  padding: 12px 0 !important;
}

.row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
overflow: hidden;
color: var(--greyscale-text-main, #060809);
text-overflow: ellipsis;
font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
letter-spacing: 0.25px;
}
.dialogHeader{
  color: var(--color-greyscale-text-main, #343637);
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 130%; /* 20.8px */
}
.value {
overflow: hidden;
color: var(--greyscale-text-main, #060809);
text-overflow: ellipsis;
font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 20px; 
letter-spacing: 0.25px;
}
/* Content Styles */
.saving-content,
.message-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 36px 24px 36px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 320px;
  margin: 1rem;
}

.saving-content h3,
.message-content h3 {
  margin: 1rem 0 0.5rem 0;
  color: #333;
  font-weight: 500;
}

.saving-content p,
.message-content p {
  margin: 0 0 1rem 0;
  color: #666;
  font-size: 0.9rem;
}
    .warning {
      color: #e53935 !important;
      font-weight: 500;
    }
   ::ng-deep .mat-mdc-button:not(:disabled):hover, .mat-mdc-button:not(:disabled):focus{
  background: #fff !important;
}
  

  `]
})
export class OverConsumtionDialog {
    constructor(private dialogRef: MatDialogRef<OverConsumtionDialog>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any) {

    }
    review() {
        this.dialogRef.close('review');     // return "sync"
    }

    continue() {
        this.dialogRef.close('close'); // return "continue"
    }
}
